__turbopack_context__.v({
  "jobsCardsList": "H66ynq_jobsCardsList",
  "jobsCardsList__empty": "H66ynq_jobsCardsList__empty",
  "jobsCardsList__error": "H66ynq_jobsCardsList__error",
  "jobsCardsList__loadingMore": "H66ynq_jobsCardsList__loadingMore",
  "jobsCardsList__sentinel": "H66ynq_jobsCardsList__sentinel",
  "jobsCardsList__skeletonCard": "H66ynq_jobsCardsList__skeletonCard",
  "jobsCardsList__skeletonLeft": "H66ynq_jobsCardsList__skeletonLeft",
  "jobsCardsList__skeletonMeta": "H66ynq_jobsCardsList__skeletonMeta",
  "jobsCardsList__skeletonRight": "H66ynq_jobsCardsList__skeletonRight",
});
